// extracted by mini-css-extract-plugin
module.exports = {"container":"G_c","o":"G_bD"};